import FieldTypes from './ExtendedFieldTypes';
var ValidatorType = /*#__PURE__*/function (ValidatorType) {
  ValidatorType["StringLengthValidator"] = "{83E96D09-11C8-4132-8A8A-76D8DB8208D6}";
  return ValidatorType;
}(ValidatorType || {});
export const validateField = (fieldValue, fieldModel, formDictionaries, confirmValue) => {
  const {
    maxFileSize
  } = fieldModel;
  let validationDataModels = fieldModel.validationDataModels;
  let required = fieldModel.required;
  let validationResult = {
    isValid: true,
    error: Array()
  };
  if ((!fieldValue || fieldValue.length === 0) && required === true) {
    validationResult.isValid = false;
    let requiredMessage = retrieveDataFromDictionary(formDictionaries, 'Required validation Message');
    requiredMessage = requiredMessage.phrase.replace('{0}', fieldModel.title);
    validationResult.error.push(requiredMessage);
  }
  if (validationDataModels && validationResult.isValid) {
    validationDataModels.forEach(validator => {
      let paramtersRegex = validator.parameters;
      if (typeof paramtersRegex === 'string' && paramtersRegex.length > 0) {
        let regularData = JSON.parse(paramtersRegex);
        paramtersRegex = regularData.regularExpression;
      }
      if (paramtersRegex && paramtersRegex != '^$') {
        let regex = new RegExp(paramtersRegex, 'gi');
        let match = fieldValue.match(regex);
        if (!required && fieldValue.length > 0 || required) {
          validationResult.isValid = match === null ? false : true;
          if (!validationResult.isValid) validationResult.error.push(validator.message.replace('{0}', fieldModel.title));
        }
      }
    });
  }
  const stringValidator = exportDataModel(validationDataModels, ValidatorType.StringLengthValidator);
  if (fieldModel.maxLength !== 0 && fieldValue.length > fieldModel.maxLength && stringValidator && validationResult.isValid) {
    validationResult.isValid = false;
    const message = stringValidator.message.replace('{0}', fieldModel.name).replace('{1}', fieldModel.minLength).replace('{2}', fieldModel.maxLength);
    validationResult.error.push(message);
  }
  if (fieldModel.fieldTypeItemId === FieldTypes.FileUpload && validationResult.isValid) {
    if (fieldValue.length > fieldModel.maxFileCount) {
      let maximumCountErrorMessage = retrieveDataFromDictionary(formDictionaries, 'fileCount');
      maximumCountErrorMessage = maximumCountErrorMessage.phrase.replace('{0}', fieldModel.maxFileCount).replace('{1}', fieldValue.length);
      validationResult.isValid = false;
      validationResult.error.push(maximumCountErrorMessage);
    }
    for (let x = 0; x < fieldValue.length; x++) {
      const currentFile = Array.isArray(fieldValue) ? fieldValue[x] : fieldValue.item(x);
      if (!currentFile) continue;
      if (fieldModel.allowedContentTypes.length > 0 && fieldModel.allowedContentTypes.indexOf(currentFile.type) === -1) {
        let typeErrorMessage = retrieveDataFromDictionary(formDictionaries, 'fileType');
        typeErrorMessage = typeErrorMessage.phrase.replace('{0}', currentFile.type).replace('{1}', currentFile.name);
        validationResult.isValid = false;
        validationResult.error.push(typeErrorMessage);
      }
      const isValid = currentFile.size <= fieldModel.maxFileSize * 1024;
      if (!isValid) {
        let maximumSizeErrorMessage = retrieveDataFromDictionary(formDictionaries, 'fileSize');
        maximumSizeErrorMessage = maximumSizeErrorMessage.phrase.replace('{0}', `${fieldModel.maxFileSize} KB`).replace('{1}', `${Math.round(currentFile.size / 1024)} KB`).replace('{2}', currentFile.name);
        validationResult.isValid = false;
        validationResult.error.push(maximumSizeErrorMessage);
      }
    }
  }
  const isNotConfirmed = confirmValue !== null && fieldValue !== confirmValue;
  if (isNotConfirmed && validationResult.isValid) {
    validationResult.isValid = false;
  }
  if (fieldModel.fieldTypeItemId === '{50BC7E56-4660-4839-8408-1AFC7BC02E5B}') {
    const regex = new RegExp(fieldModel.regularExpression);
    if (fieldValue !== '') {
      if (!fieldValue.match(regex)) {
        let requiredMessage = retrieveDataFromDictionary(formDictionaries, 'Regular expression validation message');
        requiredMessage = requiredMessage && requiredMessage.phrase;
        validationResult.isValid = false;
        validationResult.error.push(requiredMessage);
        // validationResult.error.push([]);
      }
    }
  }
  return validationResult;
};
export const retrieveDataFromDictionary = (dictionaries, key) => {
  if (typeof dictionaries === 'undefined' || !dictionaries) return null;
  for (let index = 0; index < dictionaries.length; index++) {
    if (dictionaries[index].key === key) return dictionaries[index];
  }
  return null;
};
const exportDataModel = (validationDataModels, key) => {
  for (let index = 0; index < validationDataModels.length; index++) {
    if (validationDataModels[index].itemId === key) return validationDataModels[index];
  }
  return null;
};